// Logo y branding - Rutas desde la carpeta public
export const logoIcon = '/images/logo.svg';
export const logoPrincipal = '/images/logo-principal-web.svg';

// Iconos de servicios (agregar cuando los tengas)
// export const iconBranding = '/icons/icon-branding.svg';
// export const iconDev = '/icons/icon-dev.svg';
// export const iconUx = '/icons/icon-uiux.svg';
// export const iconConsultancy = '/icons/icon-consultancy.svg';

// Otros iconos (agregar cuando los tengas)
// export const iconArrow = '/icons/icon-arrow.svg';
// export const iconCheck = '/icons/icon-check.svg';

// Imágenes de fondo (agregar cuando las tengas)
// export const heroBg = '/backgrounds/hero-bg.svg';
// export const processBg = '/backgrounds/process-bg.svg';

// ...imports

const savedTheme = localStorage.getItem('theme'); // 'dark' | 'light' | null
// const prefersDark = window.matchMedia?.('(prefers-color-scheme: dark)').matches;

// ✅ Dark por defecto (y si existe theme guardado, respétalo)
const shouldUseDark = savedTheme ? savedTheme === 'dark' : true;

document.documentElement.classList.toggle('dark', shouldUseDark);

// ...tu ReactDOM.createRoot(...).render(...)